import { httpConsulta } from "../../../../services/apiManagement/Http.interceptor";
import { reportDTO } from './Interface/ReportDto';
import { sub } from 'date-fns';

export const getReport = async (cd: string, dataInicial?: string, dataFinal?: string): Promise<reportDTO[]> => {
  if (dataInicial && dataFinal) {

    const result = await httpConsulta.get('/getRelatorioTransporteRangeData', {
      params: {
        'data_inicio': dataInicial,
        'data_fim': dataFinal,
        'cd': cd
      }
    });

    return result.data;
  } else {

    const result = await httpConsulta.get('/getRelatorioTransporte', {
      params: {
        'cd': cd
      }
    });
    return result.data;
  }
}
